import React from "react";
import {
  Document,
  Font,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";

import FSJoeyRegular from "../../assets/fonts/sura/SuraSans-Regular.otf";
import FSJoeyMedium from "../../assets/fonts/sura/SuraSans-Seminegrita.otf";
import FSJoeyBold from "../../assets/fonts/sura/SuraSans-Negrita.otf";

Font.register({
  family: "FSJoey",
  fonts: [
    { src: FSJoeyRegular },
    { src: FSJoeyMedium, fontStyle: "lighter" },
    { src: FSJoeyBold, fontWeight: "bold" },
  ],
});

const IMAGE_CHECKBLUE =
  "https://images.prismic.io/portal-cotizacion-suramex/ef7e893e-dc7a-460d-a02a-1148c5a1f8f7_check-blue.png";

const IMAGE_CHECKRED =
  "https://images.prismic.io/portal-cotizacion-suramex/8ca071d3-f8dc-407a-b0d1-3f72faea2675_check-red.png";

const IMAGE_CHECK =
  "https://images.prismic.io/portal-cotizacion-suramex/e3a98dda-049a-412d-ab76-685df5a373b5_info.png";

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#ffffff",
    padding: 10,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
    display: "flex",
    flexDirection: "row",
  },
  sectionColumn: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
  },
  sectionHeader: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginRight: 10,
    fontFamily: "FSJoey",
    width: "25%",
  },
  sectionContent: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    margin: 10,
    padding: 10,
    fontFamily: "FSJoey",
    borderBottom: 1,
    borderBottomColor: "#CECECE",
    borderBottomStyle: "solid",
    borderTop: 1,
    borderTopColor: "#CECECE",
    borderTopStyle: "solid",
  },
  title: {
    color: "#0033A0",
    fontSize: 14,
    fontFamily: "FSJoey",
  },
  titleSection: {
    color: "#0033A0",
    fontSize: 14,
    margin: 10,
    padding: 10,
    fontFamily: "FSJoey",
  },
  price: {
    color: "#0033A0",
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 10,
  },
  description: {
    color: "#454C3E",
    fontSize: 10,
    textAlign: "center",
    lineHeight: 1.2,
    fontFamily: "FSJoey",
  },
  coverages: {
    width: "25%",
    display: "flex",
    justifyContent: "center",
    lineHeight: 1.2,
    fontSize: 10,
    marginRight: 10,
    textAlign: "center",
  },
  coveragesOne: {
    width: "25%",
    display: "flex",
    justifyContent: "flex-start",
    fontSize: 10,
    marginRight: 10,
  },
  sectionContentDescription: {
    backgroundColor: "#00aec7",
    color: "#FFF",
    fontFamily: "FSJoey",
    margin: 10,
    padding: 10,
    display: "flex",
    alignItems: "center",
    borderRadius: 15,
  },
  coveragesDescription: {
    width: "100%",
    lineHeight: 1.2,
    fontSize: 10,
    display: "flex",
    alignItems: "center",
  },
  iconimg: {
    width: 20,
    marginRight: 5,
  },
});

export default function Pdf({ modalities, coverages, coveragesAdditionals, subTitle }) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <View style={styles.sectionHeader}>
            <Text style={styles.title}>Elige tu cobertura</Text>
          </View>
          {modalities &&
            modalities.map((modalitie) => (
              <View style={styles.sectionHeader}>
                <Text style={styles.title}>{modalitie.modality}</Text>
                <Text style={styles.price}>${Math.trunc(modalitie.value)}</Text>
                <Text style={styles.description}>{modalitie.description}</Text>
              </View>
            ))}
        </View>
        <View style={styles.sectionColumn}>
          {coverages &&
            coverages.map((coverage) => (
              <View>
                <View style={styles.sectionContent}>
                  <Text style={styles.coveragesOne}>
                    {coverage.description}
                  </Text>
                  {modalities.map((modalitie) => (
                    <Text style={styles.coverages}>
                      {coverage.modalities[modalitie.modalityId]
                        ? coverage.modalities[modalitie.modalityId].description
                        : "-"}
                    </Text>
                  ))}
                </View>
                {coverage.tooltip && (
                  <View style={styles.sectionContentDescription}>
                    <Text style={styles.coveragesDescription}>
                      <Image source={IMAGE_CHECK} style={styles.iconimg} />
                      <Text>{coverage.tooltip}</Text>
                    </Text>
                  </View>
                )}
              </View>
            ))}
        </View>
        <View>
          <Text style={styles.titleSection}>{subTitle}</Text>
        </View>
        <View style={styles.sectionColumn}>
          {coveragesAdditionals &&
            coveragesAdditionals.map((covAdd) => (
              <View>
                <View style={styles.sectionContent}>
                  <Text style={styles.coveragesOne}>{covAdd.description}</Text>
                  {modalities.map((modalitie) => (
                    <Text style={styles.coverages}>
                      <Text>
                        <Image
                          source={
                            covAdd.modalities[modalitie.modalityId]
                              ? IMAGE_CHECKBLUE
                              : IMAGE_CHECKRED
                          }
                        />
                      </Text>
                    </Text>
                  ))}
                </View>
                {covAdd.tooltip && (
                  <View style={styles.sectionContentDescription}>
                    <Text style={styles.coveragesDescription}>
                      <Image source={IMAGE_CHECK} style={styles.iconimg} />
                      <Text>{covAdd.tooltip}</Text>
                    </Text>
                  </View>
                )}
              </View>
            ))}
        </View>
      </Page>
    </Document>
  );
}
